import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { isDesktop } from 'react-device-detect';
import { connect } from 'react-redux';
import { getBrandConfig, getCurrentBrand } from '../../../helpers/brand';
import { MEMORY_STORE } from '../../../helpers/constants/storage';

@connect(state => ({
  local: state.local,
  currentBrand: state.memory?.[MEMORY_STORE.CURRENT_BRAND] || getCurrentBrand(),
}))

/**
 * Renders the current logged username with picture
 */
class LogoMobile extends Component {
  state = {};

  componentDidMount() {
    if (isDesktop) {
      const logoMobileContainer = document.querySelector(
        '.fp-container.logo-mobile'
      );
      if (logoMobileContainer) {
        logoMobileContainer.style.display = 'none';
      }
    }
  }

  render() {
    if (isDesktop) {
      return <></>;
    }

    const brandConfig = getBrandConfig();
    const logoSrc = brandConfig.logoPath;
    const logoAlt = `${brandConfig.name} Logo`;
    const brandClass = brandConfig.name.toLowerCase();

    return (
      <div className={`logo-container brand-${brandClass}`}>
        <div className="logo-content">
          <p className="logo-name">
            <img src={logoSrc} alt={logoAlt} className="logo" />
          </p>
        </div>
      </div>
    );
  }
}

LogoMobile.propTypes = {
  local: PropTypes.object,
  currentBrand: PropTypes.string,
};

export default LogoMobile;
